var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Select',{attrs:{"multiple":"","filterable":""},on:{"change":_vm.onChange},model:{value:(_vm.selectedValues),callback:function ($$v) {_vm.selectedValues=$$v},expression:"selectedValues"}},_vm._l((_vm.items),function(item){return _c('Option',{key:item.id,attrs:{"value":item.code,"label":item.code}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }